import React, { Component } from "react";
import { Button, Icon } from "@culturehq/components";
import { t } from "app/utils";

import surveyItemTypes from "constants/surveyItemTypes";

import SurveyItem from "./SurveyItem";
import SurveyItemResponseOptions from "./SurveyItemResponseOptions";

const emptySurveyItem = {
  prompt: "",
  minRange: "",
  maxRange: "",
  itemType: "",
  responseOptions: []
};

const initialState = {
  success: false,
  loading: false,
  surveyItem: { ...emptySurveyItem, responseOptions: [] }
};

const PrintItemTypeOption = ({ itemType, currentSurveyItem, onTypeSelect }) => {
  if (!itemType || !itemType.value) return null;

  const isSelected = currentSurveyItem.itemType === itemType.value;

  // Prevent editing of survey type for existing questions
  if (currentSurveyItem.id && !isSelected) {
    return null;
  }

  return (
    <div className="SurveyItemTypeOptionWrapper">
      <Button
        aria-label={`${isSelected ? t("Selected") : t("Unselected")} ${itemType.name} ${itemType.description}`}
        className={`SurveyItemTypeOption ${isSelected ? "active" : "inactive"}`}
        onClick={() => onTypeSelect(itemType.value)}
      >
        <Icon icon={itemType.icon} />
        <p className="title">{itemType.name}</p>
        <p>{itemType.description}</p>
      </Button>
    </div>
  );
};

const SurveyItemRangeFields = ({ surveyItem, onChange }) => (
  <>
    <div className="col-sm-6">
      <div className="form-group">
        <h2>Minimum Value</h2>
        <div>
          <input
            aria-label={t("Enter the minimum value")}
            className="input form-control"
            type="number"
            name="minRange"
            value={surveyItem.minRange}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
    <div className="col-sm-6">
      <div className="form-group">
        <h2>Maximum Value</h2>
        <div>
          <input
            aria-label={t("Enter the maximun value")}
            className="input form-control"
            type="number"
            name="maxRange"
            value={surveyItem.maxRange}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  </>
);

class SurveyItemBuilder extends Component {
  state = initialState;

  componentDidMount() {
    this.initialize();
  }

  componentWillUnmount() {
    this.initialize();
  }

  handleItemTypeClick = value => {
    const { surveyItem } = this.state;
    surveyItem.itemType = value;
    this.setState({ surveyItem });

    this.handleChange({
      target: {
        name: "itemType",
        value
      }
    });
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { surveyItem } = this.state;

    if (onSubmit) {
      onSubmit(surveyItem);
    }
  };

  handleChange = event => {
    const { surveyItem } = this.state;
    surveyItem[event.target.name] = event.target.value;
    this.setState({ surveyItem });
  };

  handleResponseOptionsChange = responseOptions => {
    this.handleChange({
      target: {
        name: "responseOptions",
        value: responseOptions
      }
    });
  };

  initialize() {
    const { input } = this.props;

    this.setState({
      ...initialState,
      surveyItem: input || { ...emptySurveyItem, responseOptions: [] }
    });
  }

  render() {
    const { surveyItem = {} } = this.state;

    return (
      <div className="SurveyItemBuilderForm">
        <div className="row">
          <div className="col-sm-8">
            <div className="col-sm-12">
              <h2>What type of question?</h2>

              <div className="SurveyItemTypeOptions clearfix">
                {surveyItemTypes.map(type => (
                  <PrintItemTypeOption
                    itemType={type}
                    key={type.value}
                    currentSurveyItem={surveyItem}
                    onTypeSelect={this.handleItemTypeClick}
                  />
                ))}
              </div>
            </div>

            {surveyItem.itemType && (
              <div className="col-sm-12">
                <div className="form-group">
                  <h2>Question</h2>
                  <div>
                    <input
                      aria-label={t("Enter the question")}
                      className="input form-control"
                      type="text"
                      name="prompt"
                      value={surveyItem.prompt}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
              </div>
            )}

            {surveyItem.itemType === "range" && (
              <SurveyItemRangeFields
                surveyItem={surveyItem}
                onChange={this.handleChange}
              />
            )}

            {["multi_choice_one", "multi_choice_many"].includes(surveyItem.itemType) && (
              <div className="col-sm-12">
                <h2>Answer Choices</h2>
                <SurveyItemResponseOptions
                  responseOptions={surveyItem.responseOptions}
                  onChange={this.handleResponseOptionsChange}
                />
              </div>
            )}

            {surveyItem.itemType && surveyItem.prompt && (
              <div className="col-sm-12">
                <Button onClick={this.handleSubmit}>
                  Save Survey Question
                </Button>
              </div>
            )}
          </div>
          <div className="col-sm-4 hidden-xs">
            <h2>Question Preview</h2>

            <SurveyItem surveyItem={surveyItem} />
          </div>
        </div>
      </div>
    );
  }
}

export default SurveyItemBuilder;
